import React, {Component} from 'react';

import GlobalSearch from "../components/GlobalSearch";
import ObjectSearch from "../components/ObjectSearch";

class ObjectAndGlobalSearch extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<GlobalSearch {...this.props}/>
				<ObjectSearch {...this.props}/>
			</div>
		)
	}
}
export default ObjectAndGlobalSearch;



// WEBPACK FOOTER //
// ./src/js/pages/ObjectAndGlobalSearch.js